<template>
    <div>
        <q-card class="shadow-0">
            <q-card-section class="row justify-between">
                <div class="text-h6"> Certificado Digital
                </div>
                <q-btn outline icon="save" label="Guardar" color="primary" class="q-mr-sm"
                    @click="subirCertificado()" />
            </q-card-section>
            <q-separator />
            <q-card-section>
                <div class="row q-col-gutter-md">
                    <div class="col-12  ">
                        <q-file dense outlined v-model="archivoCer" label="Archivo .cer" accept=".cer" />
                    </div>

                    <div class="col-12 ">
                        <q-file dense outlined v-model="archivoKey" label="Archivo .key" accept=".key" />
                    </div>

                    <div class="col-12 ">
                        <q-input dense outlined v-model="password" label="Contraseña del Certificado" type="password" />
                    </div>

                    <div class="col-12 " v-if="certificadoSubido">
                        <q-separator spaced />
                        <q-banner dense class="bg-green-1 text-green-10 q-mt-md">
                            Certificado cargado correctamente.
                        </q-banner>
                    </div>
                    <div class="col-12 " v-else>
                        <q-separator spaced />
                        <q-banner dense class="bg-red-1 text-red-10 q-mt-md">
                            El certificado no ha sido cargado.
                        </q-banner>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import axios from 'axios'
import { QSpinnerClock } from 'quasar'


export default {
    name: 'CertificadoDigital',
    components: {
    },
    data() {
        return {
            archivoCer: null,
            archivoKey: null,
            password: '',
            certificadoSubido: false
        }
    },
    created() {
        this.obtenerDatos()
    },
    methods: {
        async subirCertificado() {
            if (!this.archivoCer || !this.archivoKey || !this.password) {
                this.$q.notify({ type: 'warning', message: 'Completa todos los campos' })
                return
            }
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })

            const archivoC = await this.convertirABase64(this.archivoCer);
            let nombreCer = this.archivoCer.name;
            let archivoCer = archivoC;


            const archivok = await this.convertirABase64(this.archivoKey);
            let nombreKey = this.archivoKey.name;
            let archivoKey = archivok;


            const formData = {
                tipo: 'CSD',
                nombreCer: nombreCer,
                archivoCer: archivoCer,
                nombreKey: nombreKey,
                archivoKey: archivoKey,
                password: this.password,
                fechaVigencia: '',
                fechaCreacion: '',
            }
            console.log(formData)
            try {
                await axios.put('Configuracion/PostCertificado/', formData)
                this.certificadoSubido = true
                this.$q.loading.hide()
                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Certificado subido con éxito' })
            } catch (err) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Error al subir el certificado' })
            }
        },

        async obtenerDatos() {
            try {
                const res = await axios.get('Configuracion/GetCertificado')
                this.form = res.data
                if (!this.form.archivoCer || !this.form.archivoKey || !this.form.password) {
                    this.certificadoSubido = false
                } else {
                    this.certificadoSubido = true
                }

            } catch (err) {
                console.error(err)
            }
        },

        convertirABase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
    }
}
</script>